import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { toRef } from "vue";
import { useGridGenerator } from "@/views/Calculators/ApartmentPlan/composables/useGridGenerator";
import { BoundingBox } from "@/types/stage";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoShooLines',
  props: {
    boundingBox: {}
  },
  setup(__props: any) {

const props = __props;

const boundingBoxRef = toRef(props, "boundingBox");

const { gridLines } = useGridGenerator(
  boundingBoxRef,
  3,
  2,
  "orange",
  "orange"
);

return (_ctx: any,_cache: any) => {
  const _component_v_line = _resolveComponent("v-line")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gridLines), (line, i) => {
    return (_openBlock(), _createBlock(_component_v_line, {
      key: 'grid-' + i,
      config: line
    }, null, 8, ["config"]))
  }), 128))
}
}

})